import { connect } 		from 'react-redux'
import Login 			from '../auth/Login';
import { logOutAction } from '../../actions/authActions'

const mapStateToProps = state => {
    return {
      account: state.account
    }
}

const mapDispatchToProps = dispatch => {
    return {
      logOut: () => {
        dispatch(logOutAction())
      }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/components/containers/AuthContainer.js